import Req from '../../$axios';

const serviceModule = {
  // 岗位分类列表
  jobTypeList(params) {
    return Req({
      url: 'jobTypes/index',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 新增岗位分类
  jobAddMsg(params) {
    return Req({
      url: 'jobTypes/save',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 岗位分类详情
  jobTypeDetail(params) {
    return Req({
      url: 'jobTypes/read',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 更新岗位分类
  jobTypeUpdate(params) {
    return Req({
      url: 'jobTypes/update',
      method: 'post',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 删除岗位分类
  jobTypeDelete(params) {
    return Req({
      url: 'jobTypes/delete',
      method: 'delete',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  }, // 职位
  getUserJobLevel(params) {
    return Req({
      url: 'jobs/index',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  addUserJbo(params) { // 新增职位
    return Req({
      url: 'jobs/save',
      method: 'post',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  updateUserJbo(params) { // 更新职位
    return Req({
      url: 'jobs/update',
      method: 'post',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  deleteUserJob(params) { // 新增职位
    return Req({
      url: 'jobs/delete',
      method: 'delete',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
};

export default {
  ...serviceModule
};
